;(function () {

"use strict";

var sendEmail = false;

var ImportFormView = Backbone.View.extend({
  initialize: function () {
    console.log('init import form view');
  },
  submit: function (e) {
    this.post();
    return false;
  },
  post: function (e) {
    console.log('completed input. sending data');

    var formData = new FormData();
    var files = this.$el.find('input[type="file"]')[0].files;
    var len = files.length;

    formData.append("__shop__", window.data.shop);

    for (var i = 0; i < len; i++) {
      formData.append("import", files[i]);
    }

    formData.append('object-type', this.$el.find('select').val());
    formData.append('identifier', this.$el.find('input[type="radio"]:checked').val());

    if (sendEmail) {
      if (this.$el.find('input.alt-email').val()) {
        formData.append('email', this.$el.find('input.alt-email').val());
      }
    }

    var request = new XMLHttpRequest();
    request.addEventListener("load", _.bind(this.onComplete, this));
    request.open("POST", "import-csv");
    request.setRequestHeader("Authorization", "Bearer " + window.sessionToken);
    request.send(formData);

    // ShopifyApp.flashNotice("Starting Import");
    ShopifyApp.Bar.loadingOn();
  },
  onComplete: function (d) {
    ShopifyApp.Bar.loadingOff();

    try {
      d = JSON.parse(d.srcElement.responseText);    
    } catch(e) {
      ShopifyApp.Modal.alert({
        title: 'Error Running Import',
        message: "The import did not run successfully. Please ensure you filled out the form correctly. If the problem persists please email us at jason@thebestagency.com."
      });

      return;
    }

    if (d.status === 'error') {
      ShopifyApp.Modal.alert({
        title: 'Import Failed',
        message: d.message
      });
    } else {
      ShopifyApp.Modal.alert({
        title: 'Import Successful',
        message: "The import process has begun. It should take no more than one hour to complete. Please do not modify your store during this time. When the import is finished the store owner will receive an email in his or her inbox."
      });

      this.$el.find('button[type="submit"]').addClass('disabled').attr('disabled', 'disabled').text('Running Import');
    }
  },
  events: {
    'submit': 'submit'
  }
});

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init import csv page');
    new ImportFormView({el: this.$el.find('form').first()});
  },
  events: {
    'change select': function (e) {
      var type = e.target.value;

      /* Reset */
      this.$el.find('input[value="handle"]').attr('disabled', false);
      this.$el.find('input[value="sku"]').attr('disabled', false);
      this.$el.find('input[value="id"]').attr('disabled', false);

      if (type === 'product') {
        /* Do nothing */
      } else if (type === 'variant') {
        this.$el.find('input[value="handle"]').attr('disabled', 'disabled');

        var selected = this.$el.find('input[type="radio"]:checked').val();
        if (selected === 'handle') {
          this.$el.find('input[value="sku"]').click();
        }
      } else if (type === 'article' || type === 'custom_collection' || type === 'smart_collection' || type === 'blog' || type === 'page') {
        this.$el.find('input[value="sku"]').attr('disabled', 'disabled');

        var selected = this.$el.find('input[type="radio"]:checked').val();
        if (selected === 'sku') {
          this.$el.find('input[value="handle"]').click();
        }
      } else if (type === 'order' || type === 'customer' || type === 'shop') {
        this.$el.find('input[value="sku"]').attr('disabled', 'disabled');
        this.$el.find('input[value="handle"]').attr('disabled', 'disabled');

        var selected = this.$el.find('input[type="radio"]:checked').val();
        if (selected === 'handle' || selected === 'sku') {
          this.$el.find('input[value="id"]').click();
        }
      }
    },
    'change input[name="diff-email"]': function (e) {
      if ($(e.target).is(':checked')) {
        sendEmail = true;
        $(e.target).parent().parent().next().show();
      } else {
        sendEmail = false;
        $(e.target).parent().parent().next().hide();
      }
    }
  }
});

module.exports = PageView;

}());